import { create } from "zustand";

export const useChangeRequestStore = create((set) => ({
    items: [],
    loading: false,
    error: null,
    selectedItem: null,
    columnFilters: {},
    uniqueValues: {},
    paginationData: {
        currentPage: 1,
        itemsPerPage: 10,
        totalItems: 0,
        totalPages: 0,
    },
    isFormOpen: false,
    isEditMode: false,
    isDeleteDialogOpen: false,
    itemToDelete: null,
    isDetailDialogOpen: false,
    changeRequestToView: null,
    detailItem: null,
    detailLoading: false,
    detailError: null,
    detailRequestId: null,

    setLoading: (loading) => set({ loading }),
    setDetailItem: (detailItem) => set({ detailItem }),
    setDetailLoading: (detailLoading) => set({ detailLoading }),
    setDetailError: (detailError) => set({ detailError }),
    beginDetailFetch: (id) => set((state) => ({
        detailRequestId: String(id),
        detailLoading: true,
        detailError: null,
        detailItem: String(state.detailItem?._id) === String(id) ? state.detailItem : null,
    })),
    setError: (error) => set({ error }),
    clearError: () => set({ error: null }),
    setItems: (items) => set({ items }),
    setSelectedItem: (selectedItem) => set({ selectedItem }),
    setColumnFilters: (columnFilters) => set({ columnFilters }),
    setUniqueValues: (uniqueValues) => set({ uniqueValues }),
    setPaginationData: (data) => set((state) => ({
        paginationData: {
            ...state.paginationData,
            ...data,
            currentPage: data.page || data.currentPage || state.paginationData.currentPage,
            itemsPerPage: data.pageSize || data.itemsPerPage || state.paginationData.itemsPerPage,
            totalItems: data.total || data.totalItems || state.paginationData.totalItems,
            totalPages: data.totalPages || state.paginationData.totalPages,
        },
    })),
    openCreateForm: () => set({ isFormOpen: true, isEditMode: false, selectedItem: null, error: null }),
    openEditForm: (item) => set({ isFormOpen: true, isEditMode: true, selectedItem: item, error: null }),
    closeForm: () => set({ isFormOpen: false, selectedItem: null, error: null }),
    openDeleteDialog: (item) => set({ isDeleteDialogOpen: true, itemToDelete: item, error: null }),
    closeDeleteDialog: () => set({ isDeleteDialogOpen: false, itemToDelete: null }),
    openDetailDialog: (item) => set({ isDetailDialogOpen: true, changeRequestToView: item }),
    closeDetailDialog: () => set({ isDetailDialogOpen: false, changeRequestToView: null }),
}));
